import { Injectable } from '@angular/core';

import { iif, Observable, of, switchMap, timer } from 'rxjs';

import { isNullOrUndefined } from 'src/app/_shared/shared.functions';
import { IApiService } from 'src/app/chat-ai/models/chat-ai.models';
import { MessageProvider } from 'src/app/chat-ai/services/api/demo/message-provider.class';

@Injectable()
export class ChatAiDemoApiService implements IApiService {
    private readonly messageProvider: MessageProvider = new MessageProvider();

    getBotResponse(text: string): Observable<string> {
        const delayMs: number = Math.floor(Math.random() * (10000 - 7000 + 1)) + 7000;

        return timer(delayMs).pipe(
            switchMap(() =>
                iif(
                    () => isNullOrUndefined(text),
                    of(this.messageProvider.getDefaultMessage()),
                    of(this.messageProvider.getMessage(text))
                )
            )
        );
    }
}
